import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import GhaWhPoAwbException from '../../../models/GhaWhPoAwbException';

import AwbReport from './awbReport';

interface AwbReportContainerProps {
  type: string;
  code: string;
  number: string;
  orderNumber: string;
  receiveError: Function;
  handleClose: (type: string) => void;
};
  
interface AwbReportContainerState {
  awbNumber: string;
  exceptions: GhaWhPoAwbException;
};

class awbReportContainer extends Component<AwbReportContainerProps, AwbReportContainerState> {

  state = {
    awbNumber: '',
    exceptions: {
      contents_damaged: false,
      exception: [
        {
          id: -1,
          name: '',
          selected: false
        }
      ],
      note: '',
      packaging: [
        {
          id: -1,
          name: '',
          selected: false
        }
      ],
      parts: [],
      not_delivered_pieces: 0,
      not_delivered_weight: 0,
      attachments: new Array<string>(),
    }
  }
  
  componentDidMount() {

    pickupOrderRemote.getGhaPoAwbWhExceptions(this.props.orderNumber, this.props.code, this.props.number).then((resp: ApiResponse<GhaWhPoAwbException>) => {

      const exceptions: GhaWhPoAwbException | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;
      const awb: string = this.props.code + '-' + this.props.number;

      if (exceptions) {
        this.setState({ exceptions, awbNumber: awb });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  render() {

    return (
      
      <AwbReport
        awbNumber={ this.state.awbNumber }
        exceptions={ this.state.exceptions }
        type={ this.props.type }
        handleClose={ this.props.handleClose }
      />
    )
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};
  
export default connect(null, mapDispatchToProps)(awbReportContainer);
